export const RADIO_SETTING_REQUEST_GET = 'RADIO_SETTING_REQUEST_GET';
export const RADIO_SETTING_RESPONSE_GET_SUCCESS =
	'RADIO_SETTING_RESPONSE_GET_SUCCESS';
export const RADIO_SETTING_RESPONSE_GET_FAIL =
	'RADIO_SETTING_RESPONSE_GET_FAIL';

export const RADIO_SETTING_DATA_RESPONSE_GET_SUCCESS =
	'RADIO_SETTING_DATA_RESPONSE_GET_SUCCESS';
export const RADIO_SETTING_DATA_RESPONSE_GET_FAIL =
	'RADIO_SETTING_DATA_RESPONSE_GET_FAIL';

export const RADIO_SETTING_ATCP_RESPONSE_GET_SUCCESS =
	'RADIO_SETTING_ATCP_RESPONSE_GET_SUCCESS';
export const RADIO_SETTING_ATCP_RESPONSE_GET_FAIL =
	'RADIO_SETTING_ATCP_RESPONSE_GET_FAIL';

export const RADIO_SETTING_WIPS_RESPONSE_GET_SUCCESS =
	'RADIO_SETTING_WIPS_RESPONSE_GET_SUCCESS';
export const RADIO_SETTING_WIPS_RESPONSE_GET_FAIL =
	'RADIO_SETTING_WIPS_RESPONSE_GET_FAIL';

export const EDIT_RADIO_SETTING = 'EDIT_RADIO_SETTING';
export const EDIT_RADIO_SETTING_COMPLETE = 'EDIT_RADIO_SETTING_COMPLETE';

export const EDIT_WIPS = 'EDIT_WIPS';
export const EDIT_WIPS_COMPLETE = 'EDIT_WIPS_COMPLETE';

export const EDIT_ATCP = 'EDIT_ATCP';
export const EDIT_ATCP_COMPLETE = 'EDIT_ATCP_COMPLETE';

export const ACCESS_POINT_RADIO_SETTING_DATA_RESPONSE_GET_SUCCESS =
	'ACCESS_POINT_RADIO_SETTING_DATA_RESPONSE_GET_SUCCESS';
export const ACCESS_POINT_RADIO_SETTING_DATA_RESPONSE_GET_FAIL =
	'ACCESS_POINT_RADIO_SETTING_DATA_RESPONSE_GET_FAIL';
export const ACCESS_POINT_RADIO_SETTING_API_LOADING = 'ACCESS_POINT_RADIO_SETTING_API_LOADING'

export const TIP_RADIO_GET = 'TIP_RADIO_GET';
export const TIP_RADIO_GET_SUCCESS = 'TIP_RADIO_GET_SUCCESS';
export const TIP_RADIO_GET_ERROR = 'TIP_RADIO_GET_ERROR';

export const TIP_RADIO_UPDATE = 'TIP_RADIO_UPDATE';
export const TIP_RADIO_UPDATE_SUCCESS = 'TIP_RADIO_UPDATE_SUCCESS';
export const TIP_RADIO_UPDATE_ERROR = 'TIP_RADIO_UPDATE_ERROR';

export const EDIT_ACCESS_POINT_RADIO_SETTING =
	'EDIT_ACCESS_POINT_RADIO_SETTING';
export const EDIT_ACCESS_POINT_RADIO_SETTING_COMPLETE =
	'EDIT_ACCESS_POINT_RADIO_SETTING_COMPLETE';

export const OFFLINE_AP_INDICATION = 'OFFLINE_AP_INDICATION';

export const GET_DEVICE_MODEL = 'GET_DEVICE_MODEL';
export const GET_DEVICE_MODEL_SUCCESS = 'GET_DEVICE_MODEL_SUCCESS';
export const GET_DEVICE_MODEL_FAIL = 'GET_DEVICE_MODEL_FAIL';
export const GET_DEVICE_MODEL_RESET = 'GET_DEVICE_MODEL_RESET';
